import React, { useEffect, useState } from 'react'
import { AbaEntrega, Entrega, Turno } from "./aba-entrega/aba-entrega";
import { AbaTransportadora } from "./aba-transportadora/AbaTransportadora";
import { AbaFrete, Frete } from "./frete/AbaFrete";
import { AbaTipoEntrega, TipoEntrega } from "./aba-tipo-entrega/AbaTipoEntrega";
import { Abas } from "../abas/Abas";
import {
    ListaIndicadoresDePresenca,
    ListaRedespacho,
    ListaRoteiro,
    ListaTipoFrete,
    ListaTransportadora,
    Transportadora
} from "../../types/AbaTransportadora";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { NomeTela } from "./TelaEntregaContainer";

export type TelaEntregaProps = {
    onLimpar: () => void
    todosTurnos: Turno[];
    entrega: Entrega;
    mostrarGuiaFrete: boolean
    dataMaximaParaPrevisaoEntrega?: { year: number, month: number, day: number }
    onAplicarEntrega: (entrega: Entrega) => void;
    definirPrevisaoEntregaPorItem: boolean;
    vendaComEntregaPosterior: boolean;
    habilitarInputsAbaEntrega: boolean;
    habilitarExpedicaoExpressa: boolean;
    usarSeparacaoExpedicaoExpressa: boolean;
    usarDefinirPrevisaoEntregaPorItem: boolean;
    replicarData: (entrega: Entrega, alterarDataPrevista: boolean) => void;
    incluir: boolean;
    alterar: boolean;
    listaTransportadora: ListaTransportadora[];
    listaRedespacho: ListaRedespacho[];
    listaTipoFrete: ListaTipoFrete[];
    listaRoteiro: ListaRoteiro[];
    listaIndicadoresDePresenca: ListaIndicadoresDePresenca[] // 458066
    transportadora: Transportadora;

    onAplicarTransportadora: (transportadora: Transportadora) => void;
    permitirAlterarRoteiro: boolean;
    utilizaCalculoFreteFaixaMarkup: string;
    habilitaEdicaoCustoFrete: boolean;
    custoFretePendente: boolean;
    todosFrete: Frete[];
    onEditarFrete: (frete: Frete) => void;
    tiposEntrega: TipoEntrega[];
    onEditarTipoEntrega: (tipoEntrega: TipoEntrega) => void;
    parametroUtilizaCargaFrete: string
    vendaComEntregaExpressa: boolean
    telaExibida: NomeTela
    onAlterarTela: (tela: NomeTela) => void
    onAlterarValorEntrega: (dados: Entrega) => void;
    onAlterarValorTransportadora: (dados: Transportadora) => void;
    permitidoAlterarEntrega: boolean
    permitidoEditarTipoEntrega: boolean
    permitidoEditarFrete: boolean
    somenteLeitura: boolean
    mostrarNomeComoCodigo: boolean
}

export const TelaEntrega = (props: TelaEntregaProps) => {
    return <>
        {
            <Breadcrumb2Container
                passos={["Entrega"]}
                id="TelaEntregaBreadcrumb" 
                exibirBotaoLimpar={(props.telaExibida === "Entrega" || props.telaExibida === "Transportadora") && !props.somenteLeitura}
                exibirBotaoVoltar={false}
                onBotaoLimparClicado={props.onLimpar}
            />
        }
        <Abas
            abas={[
                { nome: "Entrega" },
                { nome: "Transportadora" },
                { nome: "Frete" },
                { nome: "Tipo Entrega" },
            ]}
            id="TelaAbregaAbas"
            nomeAbaSelecionada={props.telaExibida}
            onAbaSelecionada={props.onAlterarTela}
        />
        {
            props.telaExibida === "Entrega" &&
            <AbaEntrega
                permitidoAlterar={props.permitidoAlterarEntrega}
                onAlterarValor={props.onAlterarValorEntrega}
                todosTurnos={props.todosTurnos}
                entrega={props.entrega}
                onAplicar={props.onAplicarEntrega}
                dataMaximaParaPrevisaoEntrega={props.dataMaximaParaPrevisaoEntrega}
                definirPrevisaoEntregaPorItem={props.definirPrevisaoEntregaPorItem}
                vendaComEntregaPosterior={props.vendaComEntregaPosterior}
                habilitarInputs={props.habilitarInputsAbaEntrega}
                habilitarExpedicaoExpressa={props.habilitarExpedicaoExpressa}
                usarSeparacaoExpedicaoExpressa={props.usarSeparacaoExpedicaoExpressa}
                usarDefinirPrevisaoEntregaPorItem={props.usarDefinirPrevisaoEntregaPorItem}
                replicarData={props.replicarData}
                incluir={props.incluir}
                alterar={props.alterar}
                vendaComEntregaExpressa={props.vendaComEntregaExpressa}
                somenteLeitura={props.somenteLeitura}
            />
        }
        {
            props.telaExibida === "Transportadora" &&
            <AbaTransportadora
                onValorAlterado={props.onAlterarValorTransportadora}
                listaTransportadora={props.listaTransportadora}
                listaRedespacho={props.listaRedespacho}
                listaTipoFrete={props.listaTipoFrete}
                listaRoteiro={props.listaRoteiro}
                listaIndicadoresDePresenca={props.listaIndicadoresDePresenca} // 458066
                transportadora={props.transportadora}
                onAplicar={props.onAplicarTransportadora}
                permitirAlterarRoteiro={props.permitirAlterarRoteiro}
                utilizaCalculoFreteFaixaMarkup={props.utilizaCalculoFreteFaixaMarkup}
                habilitaEdicaoCustoFrete={props.habilitaEdicaoCustoFrete}
                custoFretePendente={props.custoFretePendente}
                somenteLeitura={props.somenteLeitura}
            />
        }
        {
            props.telaExibida === "Frete" && props.mostrarGuiaFrete &&
            <AbaFrete
                permitidoEditar={props.permitidoEditarFrete}
                todosFrete={props.todosFrete}
                onEditarFrete={props.onEditarFrete}
                parametroUtilizaCargaFrete={props.parametroUtilizaCargaFrete}
            />
        }
        {
            props.telaExibida === "Tipo Entrega" &&
            <AbaTipoEntrega
                mostrarNomeComoCodigo={props.mostrarNomeComoCodigo}
                permitidoEditar={props.permitidoEditarTipoEntrega}
                tiposEntrega={props.tiposEntrega}
                onEditarTipoEntrega={props.onEditarTipoEntrega}
            />
        }
        {<section style={{ marginBottom: "30px" }} />}
    </>
}